import React from 'react';
import { Card } from 'antd';
import { FileImageItem } from '@core/features';

type ImageCardItemProps = {
  item: FileImageItem;
  isSelected?: boolean;
  loading?: boolean;
  onClick: (item: FileImageItem) => void;
};

const ImageBanner = ({ item }: { item: FileImageItem }) => {
  return (
    <div
      style={{
        background: `url("${item.url}")`,
        height: 200,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        padding: '10px 20px',
      }}></div>
  );
};

const FileImageItemCard = ({ item, loading, isSelected, onClick }: ImageCardItemProps) => {
  return (
    <Card
      onClick={() => onClick(item)}
      hoverable
      cover={<ImageBanner item={item} />}
      style={{
        maxWidth: 300,
        minWidth: 250,
        width: '32%',
        marginRight: 10,
        marginBottom: 10,
        padding: '20px 30px',
        overflow: 'hidden',
        ...(isSelected ? { border: '2px solid #4096ff' } : {}),
      }}></Card>
  );
};

export default FileImageItemCard;
